









































































import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {GetUsers, SaveDlyOvertime} from "@/api/dialysisProcess"
import {GetUtcodeList} from "@/api/specialDictionary"
import {GetPatientList} from "@/api/patient"

@Component({
	components: {}
})
export default class Roles extends AbpBase {
	@Prop() value: boolean
	@Prop() data: any
	model: any = {
		dates: [],
		inputDate:new Date(),
		dayDuration: null,
		nightDuration: null,
		patientIds:[],
	}
	dates:any = []
	users: any = []
	departs: any = []
	patients: any = []

	created() {
		this.getSelect()
		if (this.data.mode === 'edit') {
			this.model = Object.assign({}, this.data.data)
			this.model.dates = [this.model.startDate,this.model.endDate]
			if (this.model.patientId) {
				this.model.patientIds = this.model.patientId.split(';').map((item:any)=>{
					return Number(item)
				})
			}

		}
	}
	timeChange(val1:any, val2:any){
		this.dates = val1
	}
	get dialogTitle() {
		return (this.data.mode === 'add' ? '新增' : '编辑') + "加班记录"
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
	cancel(){
		this.$emit('input', false)
	}
	async save(){
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (!this.model.dates[1]) {
					this.$Message.error('请选择加班时间！')
					return
				}
				this.model.inputDate = this.formatDate(this.model.inputDate)
				this.model.startDate = this.dates[0]
				this.model.endDate = this.dates[1]
				this.model.patientId = this.model.patientIds.join(';')
				let res = await SaveDlyOvertime(this.model)
				if (res.status === 1) {
					this.$emit('save-success')
				}
			}
		})

	}
	private async getSelect() {
		let res = await GetUsers({})
		this.users = res.objects
		let res1 = await GetUtcodeList({
			SkipCount:1,
			MaxResultCount:10000
		})
		this.departs = res1.items
		let res2 = await GetPatientList()
		this.patients = res2.objects
	}

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/roomManage/overtime/addOrEdit.vue